export default __webpack_public_path__ + "static/media/cp_geo_va.8be46235.svg";